module.exports = __webpack_public_path__ + "img/just.67a44edd.png";